import { render, staticRenderFns } from "./IconReddit.vue?vue&type=template&id=6431a5f8&"
import script from "./IconReddit.vue?vue&type=script&lang=js&"
export * from "./IconReddit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports